import template from './trip-item-rail-group.html';
const DIRECTIVE_NAME = TripItemRailGroup.DIRECTIVE_NAME = 'ktTripItemRailGroup';
export default function TripItemRailGroup() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripItemRailGroupController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
        },
        link: function($scope, $elem, $attrs, tripItemRailGroupCtrl) {
            tripItemRailGroupCtrl.$onInit();
        },
    };
}

export const CSS_CLASS_PREFIX = 'trip-item-rail-group-id-';

export function TripItemRailGroupController(
    userService,
    tripItemService,
    tripItemRailGroupService,
    tripItemRecommendationService,
    tripDetailsService,
    scrollService,
    moment,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        getRailIconClass: tripItemService.getRailIconClass,
        getCssClasses,
        viewOriginalTicket,
        viewAmendedTicket,
        getArrivalStation,
        moment,
    });

    function $onInit() {
        vm.regionalSettings = userService.getRegionalSettings();
        initAmendmentIds();
        initMessages();
    }

    function initMessages() {
        const isRecommendationConfirmed = tripItemRecommendationService.isConfirmed(vm.recommendation);
        const isRecommendationCancelled = tripItemRecommendationService.isCancelled(vm.recommendation);
        const isRecommendationQuote = tripItemRecommendationService.isQuote(vm.recommendation);
        const isRecommendationDeclined = tripItemRecommendationService.isDeclined(vm.recommendation);

        vm.isTicketCancelled = (isRecommendationConfirmed || isRecommendationCancelled)
            && !!vm.model.AmendedByGroup;

        vm.isWaitingToBeAmendedByAnotherGroup = isRecommendationConfirmed
            && !vm.model.AmendedByGroup
            && !!tripItemRailGroupService.getGroupThatWillAmendCandidate(vm.model, vm.tripDetails);

        vm.isTicketAmended = (isRecommendationConfirmed || isRecommendationCancelled)
            && !!vm.model.AmendsGroup
            && !vm.isWaitingToBeAmendedByAnotherGroup;

        vm.isWaitingToAmendAnotherGroup = isRecommendationQuote
            && !!vm.model.AmendsGroup
            && !!tripItemRailGroupService.getCandidateThatWillBeAmendedByGroup(vm.model, vm.tripDetails)
            && tripDetailsService.isAmendmentPendingApproval(vm.tripDetails);

        vm.isTicketApproved = isRecommendationQuote
            && !!vm.model.AmendsGroup
            && !!tripItemRailGroupService.getCandidateThatWillBeAmendedByGroup(vm.model, vm.tripDetails)
            && tripDetailsService.isAmendmentApproved(vm.tripDetails);

        vm.isTicketDeclined = isRecommendationDeclined
            && !!vm.model.AmendsGroup;

        vm.isApprovalExpired = tripItemRecommendationService.isApprovalExpired(vm.recommendation);

        vm.isSectionGrayedOut = vm.isTicketCancelled
            || vm.isWaitingToBeAmendedByAnotherGroup;
    }

    function initAmendmentIds() {
        vm.amendedByGroup = vm.model.AmendedByGroup || tripItemRailGroupService.getGroupThatWillAmendCandidate(vm.model, vm.tripDetails) || null;
        vm.amendsGroup = vm.model.AmendsGroup || tripItemRailGroupService.getCandidateThatWillBeAmendedByGroup(vm.model, vm.tripDetails) || null;
    }

    function getCssClasses() {
        return [
            getGroupIdCssClass(vm.model.Id),
        ];
    }

    function getGroupIdCssClass(id) {
        return `${CSS_CLASS_PREFIX}${id}`;
    }

    function viewOriginalTicket() {
        const cssClass = getGroupIdCssClass(vm.amendsGroup);
        scrollService.scrollToElement(`.${cssClass}`);
    }

    function viewAmendedTicket() {
        const cssClass = getGroupIdCssClass(vm.amendedByGroup);
        scrollService.scrollToElement(`.${cssClass}`);
    }

    function getArrivalStation(group) {
        if (group.length > 0) {
            return group[group.length - 1].ArrivalStation;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-group/trip-item-rail-group/trip-item-rail-group-component.js